<template>
  <b-img
    :src="`/storage/images/logo/${appConfig.logo}`"
    :width="appConfig.logo_size"
  />
</template>
<script>
import { BImg } from 'bootstrap-vue'
import store from '@/store'

export default {
  components: {
    BImg,
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
  },
}
</script>
